import { render } from "./DialogNewDatabankFromStats.vue?vue&type=template&id=7bb8adc2"
import script from "./DialogNewDatabankFromStats.vue?vue&type=script&lang=js"
export * from "./DialogNewDatabankFromStats.vue?vue&type=script&lang=js"

import "./DialogNewDatabankFromStats.vue?vue&type=style&index=0&id=7bb8adc2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__